import { IDabellaCustomFormCustomAddressData } from "common/records/DabellaCustomFormCustomAddressRecord";
import { Nullable } from "common/types";
import {
  customAddressFromJSON,
  customAddressToJSON,
  DabellaCustomFormCustomAddressRecord,
} from "common/records/DabellaCustomFormCustomAddressRecord";
import { Record } from "immutable";

export const customFormApplicantFromJSON = (
  json: Partial<IDabellaCustomFormApplicantData>,
): DabellaCustomFormApplicantRecord => {
  const data: IDabellaCustomFormApplicantRecord = { ...(json as any) };

  if (json.physical_address) {
    data.physical_address = customAddressFromJSON(json.physical_address);
  }

  if (json.mailing_address) {
    data.mailing_address = customAddressFromJSON(json.mailing_address);
  }

  return new DabellaCustomFormApplicantRecord(data);
};

export const customFormApplicantToJSON = (
  record: DabellaCustomFormApplicantRecord,
  kind: "applicant" | "co_applicant",
): any => {
  const applicant = record.toJS() as any;

  if (record.physical_address) {
    applicant.physical_address = customAddressToJSON(
      record.physical_address,
      kind === "applicant" ? "physical" : "co_applicant_physical",
    );
  }
  if (record.mailing_address) {
    applicant.mailing_address = customAddressToJSON(record.mailing_address, "mailing");
  }

  applicant.picture_id_expiration_date = applicant.picture_id_expiration_date?.toISOString().split("T")[0];
  applicant.picture_id_issue_date = applicant.picture_id_issue_date?.toISOString().split("T")[0];
  applicant.employed_start_date = applicant.employed_start_date?.toISOString().split("T")[0];
  applicant.previous_employer_start_date = applicant.previous_employer_start_date?.toISOString().split("T")[0];
  applicant.previous_employer_end_date = applicant.previous_employer_end_date?.toISOString().split("T")[0];
  applicant.additional_income_from = applicant.additional_income_from?.toISOString().split("T")[0];

  return applicant;
};

export interface IDabellaCustomFormApplicantData {
  physical_address: Partial<IDabellaCustomFormCustomAddressData>;
  mailing_address: Partial<IDabellaCustomFormCustomAddressData>;

  first_name: string;
  middle_initial: string;
  last_name: string;
  phone: string;
  email: string;
  marital_status: string;
  us_citizen: string;

  picture_id_expiration_date: Nullable<Date>;
  picture_id_issue_date: Nullable<Date>;

  employer_name: string;
  gross_monthly_income: Nullable<number>;
  employed_start_date: Nullable<Date>;
  position: string;
  employer_phone: string;
  less_than_2_years: string;
  previous_employer: string;
  previous_employer_start_date: Nullable<Date>;
  previous_employer_end_date: Nullable<Date>;

  additional_income_source: string;
  additional_income_amount: Nullable<number>;
  additional_income_from: Nullable<Date>;
}

export interface IDabellaCustomFormApplicantRecord {
  physical_address: DabellaCustomFormCustomAddressRecord;
  mailing_address: DabellaCustomFormCustomAddressRecord;

  first_name: string;
  middle_initial: string;
  last_name: string;
  phone: string;
  email: string;
  marital_status: string;
  us_citizen: string;

  picture_id_expiration_date: Nullable<Date>;
  picture_id_issue_date: Nullable<Date>;

  employer_name: string;
  gross_monthly_income: Nullable<number>;
  employed_start_date: Nullable<Date>;
  position: string;
  employer_phone: string;
  less_than_2_years: string;
  previous_employer: string;
  previous_employer_start_date: Nullable<Date>;
  previous_employer_end_date: Nullable<Date>;

  additional_income_source: string;
  additional_income_amount: Nullable<number>;
  additional_income_from: Nullable<Date>;
}

const defaultApplicantProps: IDabellaCustomFormApplicantRecord = {
  physical_address: customAddressFromJSON({}),
  mailing_address: customAddressFromJSON({}),

  first_name: "",
  middle_initial: "",
  last_name: "",
  phone: "",
  email: "",
  marital_status: "",
  us_citizen: "",

  picture_id_expiration_date: null,
  picture_id_issue_date: null,

  employer_name: "",
  gross_monthly_income: null,
  employed_start_date: null,
  position: "",
  employer_phone: "",
  less_than_2_years: "",
  previous_employer: "",
  previous_employer_start_date: null,
  previous_employer_end_date: null,

  additional_income_source: "",
  additional_income_amount: null,
  additional_income_from: null,
};

export class DabellaCustomFormApplicantRecord
  extends Record(defaultApplicantProps)
  implements IDabellaCustomFormApplicantRecord {}
